import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook, Linkedin, Star } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_casaloco-flavors/artifacts/mrxtkbpi_Casa%20Loco%20Logo%20%285%29.png";

const Footer = () => {
  return (
    <footer data-testid="main-footer">
      {/* Main Footer */}
      <div className="relative py-12 cactus-bottom" style={{ backgroundColor: '#1A1918' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Logo & About */}
            <div>
              <div className="flex items-center mb-4">
                <img src={LOGO_URL} alt="Casa Loco" className="h-14 w-auto object-contain mr-3" />
                <span className="font-display text-xl text-white">CASA LOCO</span>
              </div>
              <p className="font-mono text-gray-500 text-xs">
                Authentic Mexican, Sized and Spiced for India. Experience the fiesta!
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-display text-base mb-4" style={{ color: '#F7B638' }}>Quick Links</h4>
              <ul className="space-y-2">
                {[
                  { to: '/food-menu', label: 'Food Menu' },
                  { to: '/express', label: 'Casa Loco Express' },
                  { to: '/about', label: 'About Us' }
                ].map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="font-mono text-gray-500 text-xs hover:text-white transition-colors uppercase tracking-wider">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Location */}
            <div>
              <h4 className="font-display text-base mb-4" style={{ color: '#F7B638' }}>Our Location</h4>
              <div className="font-mono text-gray-500 text-xs">
                <span className="font-bold text-white">Hyderabad</span><br />
                <MapPin className="w-3 h-3 inline mr-1" style={{ color: '#EE2535' }} />
                2nd Floor, Radisson Hitec City,<br />
                <span className="ml-4">Gachibowli, Hyd - 500084</span>
              </div>
            </div>

            {/* Contact & Social */}
            <div>
              <h4 className="font-display text-base mb-4" style={{ color: '#F7B638' }}>Connect With Us</h4>
              <div className="space-y-2 mb-4">
                <a href="mailto:hola@casaloco.in" className="flex items-center font-mono text-gray-500 text-xs hover:text-white transition-colors">
                  <Mail className="w-3 h-3 mr-2" style={{ color: '#F7B638' }} /> hola@casaloco.in
                </a>
                <a href="tel:+918790896655" className="flex items-center font-mono text-gray-500 text-xs hover:text-white transition-colors">
                  <Phone className="w-3 h-3 mr-2" style={{ color: '#F7B638' }} /> +91 87908 96655
                </a>
              </div>
              <div className="flex gap-2">
                {[
                  { href: 'https://www.instagram.com/casalocoindia/', icon: Instagram, hover: '#E1306C', testid: 'footer-instagram' },
                  { href: 'https://www.facebook.com/casalocoindia/', icon: Facebook, hover: '#1877F2', testid: 'footer-facebook' },
                  { href: 'https://www.linkedin.com/company/casalocoindia', icon: Linkedin, hover: '#0A66C2', testid: 'footer-linkedin' }
                ].map((s) => (
                  <a key={s.testid} href={s.href} target="_blank" rel="noopener noreferrer" data-testid={s.testid}
                    className="w-9 h-9 flex items-center justify-center text-white transition-colors"
                    style={{ border: '2px solid #4A4641' }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = s.hover; e.currentTarget.style.borderColor = s.hover; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderColor = '#4A4641'; }}
                  >
                    <s.icon className="w-4 h-4" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Casa Loco Express Locations - SEO */}
      <div className="py-6" style={{ backgroundColor: '#1A1918', borderTop: '1px solid #2A2826' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h4 className="font-display text-sm mb-3" style={{ color: '#F7B638' }}>Casa Loco Express Locations</h4>
          <div className="flex flex-wrap gap-x-4 gap-y-1">
            {[
              { label: 'Casa Loco in Hyderabad', to: '/express' },
              { label: 'Casa Loco in Chennai', to: '/express' },
              { label: 'Casa Loco in Mumbai', to: '/express' },
              { label: 'Casa Loco in Delhi', to: '/express' },
              { label: 'Casa Loco in Bangalore', to: '/express' },
              { label: 'Casa Loco in Pune', to: '/express' },
              { label: 'Mexican Food in Hyderabad', to: '/food-menu' },
              { label: 'Mexican Food in Chennai', to: '/express' },
              { label: 'Best Tacos in Hyderabad', to: '/food-menu' },
              { label: 'Best Burritos in Chennai', to: '/express' }
            ].map((item) => (
              <Link key={item.label} to={item.to} className="font-mono text-[10px] text-gray-600 hover:text-[#F7B638] transition-colors" data-testid="seo-location-link">
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="py-4" style={{ backgroundColor: '#1A1918', borderTop: '2px solid #4A4641' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="font-mono text-gray-600 text-xs">
            <Star size={8} fill="#F7B638" stroke="none" className="inline mr-1" />
            2025 Casa Loco India. All rights reserved.
            <Star size={8} fill="#F7B638" stroke="none" className="inline mx-1" />
            Authentic Mexican, Sized and Spiced for India
            <Star size={8} fill="#F7B638" stroke="none" className="inline ml-1" />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;